export default "<div *ngIf=\"service.showLoad\" class=\"load\">\r\n  <i class=\"fas fa-spinner fa-spin fa-lg\"></i>\r\n</div>\r\n"